export default __webpack_public_path__ + "static/media/bihorel10.be4c64db.jpg";